import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";


@Component({
    selector: 'cms-page',
    templateUrl: './cms-popup.component.html',
    styleUrls: ['./cms-popup.component.scss'],
    standalone: false
})
export class CmsPopupComponent implements OnInit {
	isLoadingCms: boolean = true;

	constructor(@Inject(MAT_DIALOG_DATA) public data ) {}

	ngOnInit() {
	}

	cmsFoundChange(value) {
		this.isLoadingCms = value? false : true;
	}
}
